import StaticProcessor from '@lib/processors/static-processor'

export default component => {
  const TABLE_FILTERS = []

  const TABLE_COLUMNS = [
    {
      name: 'group',
      icon: 'el-icon-document',
    },
    {
      name: 'scopes',
      sortable: false,
      icon: 'el-icon-document',
      format: v => v.join(', '),
    },
  ]

  return {
    processor: new StaticProcessor({
      component,
      data: component.preparedScopes,
      initialDataQuery: {
        defaultSort: {
          createdAt: 'desc',
        },
      },
      disableQueryString: true,
    }),
    filters: TABLE_FILTERS,
    columns: TABLE_COLUMNS,
    tableName: 'api-key-scopes',
  }
}
